import { render, staticRenderFns } from "./socio@.vue?vue&type=template&id=11f4edbf&"
import script from "./socio@.vue?vue&type=script&lang=ts&"
export * from "./socio@.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports